<template>
    <v-dialog v-model="dialog" width="100%"  persistent>
        <v-card>

            <v-app-bar class="mb-5" flat color="transparent">
                <v-btn large icon>
                    <v-icon color="primary" @click="$emit('close')">mdi-arrow-left</v-icon>
                </v-btn>

                <v-toolbar-title class="title">
                    Preview Nota de Serviço
                </v-toolbar-title>

                <v-spacer></v-spacer>

                <!-- <v-btn color="primary" @click="handleSave">
                    <span>
                        Salvar
                    </span>
                </v-btn> -->

                <!-- Botão de fechar (X) no canto superior direito, a pedido do usuário - os botões
                     do rodapé (Fechar/Imprimir/Exportar PDF) continuam intactos, sem alteração. -->
                <v-btn icon @click="$emit('close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>

            </v-app-bar>


            <v-spacer></v-spacer>

            <v-card-text ref="printArea">
                <div class="invoice-wrapper">

                    <table class="nfse-box-table mb-3">
                        <tr>
                            <td class="logo-cell" rowspan="2">
                                <v-img src="@/assets/logo_delta.jpg" contain height="70" width="130" />
                            </td>
                            <td class="title-cell" rowspan="2">
                                <div class="nfse-title">NOTA FISCAL DE SERVIÇOS ELETRÔNICA - NFS-e</div>
                                <div class="nfse-subtitle">{{ invoice.emitenteLocalEmissao || '-' }}</div>
                            </td>
                            <td class="meta-cell">
                                <span class="meta-label">Número da Nota:</span>
                                <span class="meta-value">{{ invoice.numero || 'Não Emitida' }}</span>
                            </td>
                        </tr>
                        <tr>
                            <td class="meta-cell">
                                <span class="meta-label">Data Emissão:</span>
                                <span class="meta-value">{{ formatDate(invoice.dataEmissao || invoice.createAt) }}</span>
                            </td>
                        </tr>
                    </table>

                    <table class="nfse-box-table mb-3">
                        <tr>
                            <td class="section-header" colspan="2">DADOS DO PRESTADOR</td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <strong>Nome/Razão Social:</strong> {{ invoice.emitenteRazaoSocial }}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>CNPJ/CPF:</strong> {{ invoice.emitenteCpfOrCnpj }}</td>
                            <td><strong>Insc. Municipal:</strong> {{ invoice.emitenteIm || 'Não Informado' }}</td>
                        </tr>
                        <tr>
                            <td><strong>Endereço:</strong> {{ invoice.emitenteLogradouro }}</td>
                            <td><strong>Bairro:</strong> {{ invoice.emitenteBairro }}</td>
                        </tr>
                        <tr>
                            <td><strong>Município:</strong> {{ invoice.emitenteLocalEmissao }}</td>
                            <td><strong>CNAE:</strong> {{ invoice.cnaeCodigo }}</td>
                        </tr>
                    </table>

                    <table class="nfse-box-table mb-3">
                        <tr>
                            <td class="section-header" colspan="2">DADOS DO TOMADOR</td>
                        </tr>
                        <tr>
                            <td colspan="2">
                                <strong>Nome/Razão Social:</strong> {{ invoice.tomadorRazaoSocial }}
                            </td>
                        </tr>
                        <tr>
                            <td><strong>CNPJ/CPF:</strong> {{ invoice.tomadorCpfOrCnpj }}</td>
                            <td><strong>Insc. Municipal:</strong> {{ invoice.tomadorIm || 'Não Informado' }}</td>
                        </tr>
                        <tr>
                            <td colspan="2"><strong>Endereço:</strong> {{ invoice.tomadorEndereco }}</td>
                        </tr>
                        <tr>
                            <td><strong>UF:</strong> {{ invoice.tomadorUf || '-' }}</td>
                            <td><strong>CEP:</strong> {{ invoice.tomadorCep || '-' }}</td>
                        </tr>
                    </table>

                    <table class="nfse-box-table mb-3">
                        <tr>
                            <td class="section-header">DISCRIMINAÇÃO DO SERVIÇO</td>
                        </tr>
                        <tr>
                            <td>
                                <table class="items-table">
                                    <thead>
                                        <tr>
                                            <th class="text-left">Descrição</th>
                                            <th class="text-right">Qtde.</th>
                                            <th class="text-right">Vl. Unitário</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, i) in invoice.jobItensList" :key="i">
                                            <td>{{ item.descricao }}</td>
                                            <td class="text-right">{{ item.quantidade }}</td>
                                            <td class="text-right">{{ currency(item.precoUnitario) }}</td>
                                            <td class="text-right">{{ currency(item.precoTotal) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                    </table>

                    <table class="nfse-box-table mb-3">
                        <tr>
                            <td class="section-header">ENQUADRAMENTO DO SERVIÇO</td>
                        </tr>
                        <tr>
                            <td>{{ enquadramentoServicoCodigoExibido }} - {{ invoice.enquadramentoServicoDescricao }}</td>
                        </tr>
                    </table>

                    <table class="nfse-box-table mb-3">
                        <tr>
                            <td class="section-header" colspan="3">VALORES</td>
                        </tr>
                        <tr>
                            <td><strong>Valor Bruto da Nota:</strong></td>
                            <td colspan="2" class="text-right">{{ currency(valorBruto) }}</td>
                        </tr>
                        <tr>
                            <td><strong>Base de Cálculo:</strong></td>
                            <td><strong>Alíquota ISS:</strong></td>
                            <td class="text-right">{{ invoice.aliquota != null ? invoice.aliquota + '%' : '-' }}</td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <table class="items-table taxes-table">
                                    <thead>
                                        <tr>
                                            <th class="text-right">PIS</th>
                                            <th class="text-right">COFINS</th>
                                            <th class="text-right">INSS</th>
                                            <th class="text-right">IR</th>
                                            <th class="text-right">CSLL</th>
                                            <th class="text-right">ISS</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="text-right">{{ currency(invoice.vlrPIS) }}</td>
                                            <td class="text-right">{{ currency(invoice.vlrCOFINS) }}</td>
                                            <td class="text-right">{{ currency(invoice.vrlINSS) }}</td>
                                            <td class="text-right">{{ currency(invoice.vlrIR) }}</td>
                                            <td class="text-right">{{ currency(invoice.vlrSCLL) }}</td>
                                            <td class="text-right">{{ currency(valorISS) }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2"><strong class="display-1">VALOR LÍQUIDO DA NOTA:</strong></td>
                            <td class="text-right display-1"><strong>{{ currency(invoice.vlrLiquido) }}</strong></td>
                        </tr>
                    </table>

                    <v-row class="mt-2" v-if="invoice.observacao">
                        <v-col cols="12">
                            <div><strong>Observações</strong></div>
                            <div>{{ invoice.observacao }}</div>
                        </v-col>
                    </v-row>

                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="$emit('close')">Fechar</v-btn>
                <v-btn color="primary" @click="print">Imprimir</v-btn>
                <v-btn color="secondary" @click="downloadPDF">Exportar PDF</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
import Vue from 'vue';

export default {
    name: 'PreviewNotaFiscalServico',
    props: ['open', 'notaInfo'],
    data(){
        return {
            dialog: false,
            // BUGFIX: o preview mostrava o Enquadramento com o código interno do cadastro
            // (ex.: "000010"), não o código LC116 real (ex.: "7.19") - mesma causa raiz do bug
            // corrigido em IssuanceInvoiceView.vue (item 19 do changelog): "enquadramentoServicoCodigo"
            // é um mirror do campo interno "codigo" do cadastro (NotaFiscalServicoItemServicos), não
            // do campo "servicoCodigo" (código LC116 real). Este campo guarda o código real buscado
            // ao vivo no cadastro; enquanto não resolvido, cai no mirror antigo (fallback).
            enquadramentoServicoCodigoReal: null,
            invoice: {
                /*
                number: "NS-2025-0001",
                date: new Date(),
                provider: "Prestador XYZ",
                company: {
                name: "Minha Empresa LTDA",
                address: "Rua Exemplo, 123 - Cidade - UF",
                phone: "(11) 99999-0000",
                cnpj: "12.345.678/0001-90"
                },
                client: {
                    name: "Cliente Exemplo SA",
                    address: "Av. Cliente, 999",
                    document: "99.999.999/0001-00"
                },
                service: {
                    description: "Consultoria técnica - implantação",
                    deadline: "7 dias úteis"
                },
                items: [
                    { description: "Horas de consultoria", quantity: 10, unitValue: 150.0 },
                    { description: "Configuração servidor", quantity: 1, unitValue: 500.0 }
                ],
                taxes: [
                { name: "ISS", rate: 0.05 } // 5%
                ],
                notes: "Pagamento em 30 dias. Esta é uma nota de serviço de exemplo."*/
            }
        }
    },

  methods: {

    calcularNota() {
        // 1. Valor bruto (somatório dos itens)
        const valorBruto = this.notaInfo.jobItensList.reduce((acc, item) => {
            return acc + (item.precoTotal || 0);
        }, 0);

        // 2. Retenções por item
        let totalRetencoes = 0;

        this.notaInfo.jobItensList.forEach(item => {
            const preco = item.precoTotal || 0;

            // Converte percentuais string → número (ex.: "6" → 6%)
            const parsePerc = v => (typeof v === "string" ? parseFloat(v.replace(",", ".")) : parseFloat(v)) || 0;

            const iss = item.iSS ? preco * (parsePerc(item.iSS) / 100) : 0;
            const inss = item.iNSS ? preco * (parsePerc(item.iNSS) / 100) : 0;
            const irrf = item.iRRF ? preco * (parsePerc(item.iRRF) / 100) : 0;
            const csll = item.cSLL ? preco * (parsePerc(item.cSLL) / 100) : 0;
            const pis = item.pIS ? preco * (parsePerc(item.pIS) / 100) : 0;
            const cofins = item.cOFINS ? preco * (parsePerc(item.cOFINS) / 100) : 0;

            totalRetencoes += iss + inss + irrf + csll + pis + cofins;
        });

        // 3. Valor líquido
        const valorLiquido = valorBruto - totalRetencoes;

        return {
            valorBruto,
            totalRetencoes,
            valorLiquido
        };
    },

    async resolverEnquadramentoServicoCodigoReal(enquadramentoServico) {
      this.enquadramentoServicoCodigoReal = null
      const id = Array.isArray(enquadramentoServico)
        ? (enquadramentoServico[0]?._id || enquadramentoServico[0]?.id || enquadramentoServico[0])
        : (enquadramentoServico?._id || enquadramentoServico?.id || enquadramentoServico)
      if (!id) return
      try {
        const response = await Vue.prototype.$http.get(`/Entity/NotaFiscalServicoItemServicos/${id}`)
        const servicoCodigoReal = response?.data?.data?.servicoCodigo
        if (servicoCodigoReal) {
          this.enquadramentoServicoCodigoReal = servicoCodigoReal
        }
      } catch (error) {
        console.error('Falha ao buscar o código LC116 real do Enquadramento de Serviço (preview) - mantendo fallback:', error)
      }
    },
    formatDate(d) {
      // BUGFIX: preview mostrava "Invalid Date" pois lia "invoice.date", campo inexistente no
      // registro real de FisDocService (o campo correto é "dataEmissao", com "createAt" como
      // fallback) — chamador foi corrigido para passar o campo certo; guarda aqui também contra
      // qualquer valor ausente/ inválido para nunca mais renderizar "Invalid Date" na tela.
      if (!d) return '-';
      const date = new Date(d);
      if (isNaN(date.getTime())) return '-';
      return date.toLocaleDateString('pt-BR');
    },
    currency(v) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
    },
    taxAmount(rate) {
      return +(this.subtotal * rate);
    },
    print() {
      // Abre nova janela e imprime apenas a area do preview
      const printContents = this.$refs.printArea.innerHTML;
      const popup = window.open('', '_blank', 'width=900,height=700');
      const styles = `
        <style>
          body{ font-family: Arial, Helvetica, sans-serif; padding: 20px; color:#222; }
          .company-name{ margin:0; }
          table{ width:100%; border-collapse: collapse; }
          th, td{ padding:8px; border-bottom:1px solid #eee; }
          .text-right{ text-align:right; }
        </style>
      `;
      popup.document.open();
      popup.document.write(`<html><head><title>Nota de Serviço</title>${styles}</head><body>${printContents}</body></html>`);
      popup.document.close();
      // dar um tempo pequeno para o conteúdo renderizar antes de chamar print
      popup.focus();
      setTimeout(() => {
        popup.print();
        //popup.close(); // comente se quiser que a janela permaneça
      }, 300);
    },
    async downloadPDF() {
      // Gera PDF via html2canvas + jsPDF (dependências opcionais)
      try {
        const [{ default: html2canvas }, { default: jsPDF }] = await Promise.all([
          import('html2canvas'),
          import('jspdf')
        ]);
        const node = this.$refs.printArea;
        const canvas = await html2canvas(node, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
        pdf.save(`${this.invoice.number || 'nota'} .pdf`);
      } catch (err) {
        console.error('Erro ao gerar PDF (verifique html2canvas e jspdf):', err);
        this.$emit('error', err);
        // fallback: usar print se html2canvas não estiver disponível
        this.print();
      }
    }
},

    watch: {
        open(v){
            this.dialog = v
        },

        notaInfo(info){
            if(info){
                this.invoice = info.notaFiscalServico[0]
                this.resolverEnquadramentoServicoCodigoReal(this.invoice?.enquadramentoServico)
            }
        }
    },

  computed: {
    enquadramentoServicoCodigoExibido() {
      return this.enquadramentoServicoCodigoReal || this.invoice.enquadramentoServicoCodigo
    },
    // BUGFIX: os computeds antigos (subtotal/totalTaxes/total) liam "invoice.items"/"invoice.taxes",
    // campos que nunca existem no registro real de FisDocService (o objeto "invoice" vem de
    // "notaFiscalServico[0]", cujos campos são "jobItensList"/"tributacao") — não eram mais usados
    // no template, então ficavam mortos/quebrados silenciosamente. Substituídos por computeds que
    // realmente refletem os dados do preview.
    valorBruto() {
      return (this.invoice.jobItensList || []).reduce((acc, item) => acc + (item.precoTotal || 0), 0);
    },
    valorISS() {
      // BUGFIX: "invoice.vlrISS" (campo agregado no FisDocService) vinha 0 nos registros testados
      // porque o campo ficava comentado (nunca enviado) em CreateIssuanceInvoiceView.vue - já
      // reativado lá. Para notas emitidas/salvas ANTES desse fix (vlrISS ainda ausente/0), mantém
      // dois fallbacks: soma de "valorISS" por item (se algum dia vier populado) e, por último,
      // recalcula a partir do Valor Bruto x Alíquota ISS informada na nota - nunca mais exibir
      // R$ 0,00 quando existe uma Alíquota preenchida.
      if (this.invoice.vlrISS) return this.invoice.vlrISS;
      const somaPorItem = (this.invoice.jobItensList || []).reduce((acc, item) => acc + (item.valorISS || 0), 0);
      if (somaPorItem) return somaPorItem;
      const aliquota = Number(this.invoice.aliquota) || 0;
      return this.valorBruto * (aliquota / 100);
    }
  },
}
</script>

<style scoped>
.invoice-wrapper {
  color: #222;
  font-size: 14px;
}
.display-1 {
  font-size: 1.15rem;
}
.mb-3 {
  margin-bottom: 12px;
}
.nfse-box-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #999;
}
.nfse-box-table td {
  border: 1px solid #ccc;
  padding: 6px 8px;
  vertical-align: top;
  font-size: 13px;
}
.section-header {
  background: #eef1f6;
  font-weight: bold;
  letter-spacing: .03em;
}
.logo-cell {
  width: 140px;
  text-align: center;
}
.title-cell {
  text-align: center;
}
.nfse-title {
  font-weight: bold;
  font-size: 14px;
}
.nfse-subtitle {
  font-size: 12px;
  color: #555;
}
.meta-cell {
  width: 220px;
}
.meta-label {
  display: block;
  font-size: 11px;
  color: #555;
}
.meta-value {
  font-weight: bold;
}
.items-table {
  width: 100%;
  border-collapse: collapse;
}
.items-table th, .items-table td {
  padding: 6px 8px;
  border-bottom: 1px solid #eee;
  font-size: 13px;
}
.taxes-table th {
  background: #f5f5f5;
}
@media print {
  /* Esconde dialog/overlay de fundo se necessário */
  body * {
    visibility: visible;
  }
}
</style>
